import { Grid } from '@material-ui/core'
import React from 'react'
import { css, cx } from 'react-emotion'

interface IProps {}

const fontFamily = css`
  font-family: -apple-system, BlinkMacSystemFont, ' Segoe UI ', Roboto, Oxygen,
    Ubuntu, Cantarell, ' Open Sans ', ' Helvetica Neue ', sans-serif;
`

const fullHeight = css`
  min-height: 100vh;
`

export const MainContainer: React.FC<IProps> = ({ children }) => {
  return (
    <Grid
      container
      direction="column"
      spacing={0}
      className={cx(fontFamily, fullHeight)}
    >
      {children}
    </Grid>
  )
}
